module.exports = __webpack_public_path__ + "static/sport/mb-register-btn.2345fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mb-register-btn.png
// module id = fA7q
// module chunks = 0